import { render, staticRenderFns } from "./006mojingtwo.vue?vue&type=template&id=6657dabd&scoped=true&"
import script from "./006mojingtwo.vue?vue&type=script&lang=js&"
export * from "./006mojingtwo.vue?vue&type=script&lang=js&"
import style0 from "./006mojingtwo.vue?vue&type=style&index=0&id=6657dabd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657dabd",
  null
  
)

export default component.exports